import { createSyncValidator } from 'app/validators/base'
import nameValidator from './sync/name'
import imageValidator from './sync/image'
import levelValidator from './sync/level'
import proQuoteValidator from './sync/proQuote'
import proQuoteAuthorValidator from './sync/proQuoteAuthor'
import descriptionValidator from './sync/description'
import questionValidator from './sync/question'
import categoryTagValidator from './sync/categoryTag'

const fields = [
  {
    field: 'name',
    validator: nameValidator,
  },
  {
    field: 'image',
    validator: imageValidator,
  },
  {
    field: 'level',
    validator: levelValidator,
  },
  {
    field: 'description',
    validator: descriptionValidator,
  },
  {
    field: 'proQuote',
    validator: proQuoteValidator,
  },
  {
    field: 'proQuoteAuthor',
    validator: proQuoteAuthorValidator,
  },
  {
    field: 'question',
    validator: questionValidator,
  },
]
const syncValidate = isLibraryLevel => {
  if (isLibraryLevel) {
    fields.push({
      field: 'categoryTag',
      validator: categoryTagValidator,
    })
  }
  return createSyncValidator(...fields)
}

const syncValidateForMicroActionActivity = syncValidate(false)
const syncValidateForLibraryActivity = syncValidate(true)

export { syncValidateForMicroActionActivity, syncValidateForLibraryActivity }
